export const realData = [
    {
        id: 1,
        label: 'Management',
        value: 2800
    },
    {
        id: 2,
        label: 'Process',
        value: 1800
    },
    {
        id: 3,
        label: 'Support',
        value: 1200
    },
    {
        id: 4,
        label: 'Transfer',
        value: 800
    },
    {
        id: 5,
        label: 'Security',
        value: 600
    }
];

export const analysisData = [
    {
        id: 1,
        label: 'Jan',
        value: 2800
    },
    {
        id: 2,
        label: 'Feb',
        value: 1800
    },
    {
        id: 3,
        label: 'March',
        value: 1200
    },
    {
        id: 4,
        label: 'April',
        value: 800
    },
    {
        id: 5,
        label: 'May',
        value: 600
    },
    {
        id: 6,
        label: 'June',
        value: 600
    },
    {
        id: 7,
        label: 'Jul',
        value: 1300
    },
    {
        id: 8,
        label: 'Aug',
        value: 1900
    },
    {
        id: 9,
        label: 'Sep',
        value: 3200
    },
    {
        id: 10,
        label: 'Oct',
        value: 500
    },
    {
        id: 11,
        label: 'Nov',
        value: 1700
    },
    {
        id: 12,
        label: 'Dec',
        value: 2500
    }
]